import { NavLink } from 'react-router-dom';

function Menu() {
    return (
        <div className="left-side sticky-left-side">
            <div className="left-side-inner">
                <ul className="nav nav-pills nav-stacked custom-nav">
                    <li>
                        <NavLink to="/Painel" style={({ isActive }) => isActive ? { color: 'red' } : { color: '#545e6f', background: '' }}>
                            <i className="fa fa-home fa-2x" aria-hidden="true"></i>
                            <span>Painel</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/Perfil" style={({ isActive }) => isActive ? { color: 'red' } : { color: '#545e6f', background: '' }}>
                            <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                            <span>Perfil</span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to="/Cadastro" style={({ isActive }) => isActive ? { color: 'red' } : { color: '#545e6f', background: '' }}>
                            <i className="fa fa-unlock-alt" aria-hidden="true"></i>
                            <span>Editar cadastro</span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to="/Contato" style={({ isActive }) => isActive ? { color: 'red' } : { color: '#545e6f', background: '' }}>
                            <i className="fa fa-envelope" aria-hidden="true"></i>
                            <span>Suporte</span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink to="/Sair" style={({ isActive }) => isActive ? { color: 'red' } : { color: '#545e6f', background: '' }}>
                            <i className="fa fa-sign-in" aria-hidden="true"></i>
                            <span>Sair</span>
                        </NavLink>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Menu;
